import "../dashboard-sections.css";

const DAY_DUMMY = [
  { label: "Cheeks 20 LB", value: 1200 },
  { label: "Cheeks 10 LB", value: 800  },
  { label: "Strips",        value: 600  },
  { label: "2nds",          value: 150  },
];

const TURN2_DUMMY = [
  { label: "2nds Packed",      value: 300 },
  { label: "Broker Strips",    value: 120 },
  { label: "Broker Cheeks",    value: 100 },
  { label: "Cheeks/Strips OTT",value: 750 },
];

const ShiftTable = ({ title, badge, badgeColor, icon, colHeader, rows, total, totalLabel }) => (
  <div className="pp-shift-card cmn_card">
    <div className="pp-shift-header">
      <div className="pp-shift-title-row">
        <span className="pp-shift-icon">{icon}</span>
        <span className="pp-shift-title">{title}</span>
      </div>
      {badge && (
        <span className="pp-shift-badge" style={{ background: badgeColor === "green" ? "#e6f9f5" : "#fff0ea", color: badgeColor === "green" ? "#25aa91" : "#667085" }}>
          {badge}
        </span>
      )}
    </div>
    <div className="pp-shift-col-header">
      <span>Product Category</span>
      <span>{colHeader}</span>
    </div>
    {rows.map((r, i) => (
      <div key={i} className="pp-shift-row">
        <span>{r.label}</span>
        <span>{r.value?.toLocaleString()}</span>
      </div>
    ))}
    <div className="pp-shift-total">
      <span>{totalLabel}</span>
      <span className="pp-shift-total-val">{total?.toLocaleString()}</span>
    </div>
  </div>
);

const PackingShifts = ({ dayData = DAY_DUMMY, turn2Data = TURN2_DUMMY, isLoading = false }) => {
  const dayTotal   = dayData.reduce((s, r) => s + r.value, 0);
  const turn2Total = turn2Data.reduce((s, r) => s + r.value, 0);

  return (
    <div className="pp-shifts-grid">
      <ShiftTable
        title="PACKING (DAY)"
        badge="ACTIVE"
        badgeColor="green"
        icon="☀️"
        colHeader="Volume (Units)"
        rows={dayData}
        total={dayTotal}
        totalLabel="TOTAL DAY PACK 🟠"
      />
      <ShiftTable
        title="PACKING (TURN 2)"
        badge="Night Shift"
        badgeColor="neutral"
        icon="🌙"
        colHeader="Units"
        rows={turn2Data}
        total={turn2Total}
        totalLabel="TOTAL TURN 2"
      />
    </div>
  );
};

export default PackingShifts;
